import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, catchError, throwError } from 'rxjs';

import { environment } from 'src/environments/environment';

import { ServiceDownNotificationModalComponent } from './components/service-down-notification-modal/service-down-notification-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
  private _dialog = inject(MatDialog);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(environment.api_url)) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (this._isServiceDown(error)) {
          this._openServiceDownModal();
        }

        return throwError(() => error);
      })
    );
  }

  private _openServiceDownModal(): void {
    const isAlreadyOpen = this._dialog.openDialogs.some(
      (dialog) => dialog.componentInstance instanceof ServiceDownNotificationModalComponent
    );

    if (isAlreadyOpen) {
      return;
    }

    this._dialog.open(ServiceDownNotificationModalComponent, {
      disableClose: false
    });
  }

  private _isServiceDown(error: unknown): error is HttpErrorResponse {
    return error instanceof HttpErrorResponse && error.status === 503;
  }
}
